import axios from 'axios';

export default class UserService {
    doGetInfo() {
        const headers = {
            headers: {
                'Authorization': `Bearer ${localStorage.token}`
            }
        };
        return axios.get(`/api/user`, headers);
    }

    doUpdate(params) {
        const headers = {
            headers: {
                'Authorization': `Bearer ${localStorage.token}`
            }
        };

        if (!params.password) delete params.password;
        if (!params.password_confirmation) delete params.password_confirmation;
        if (!params.image) delete params.image;
        if (params.state_id) params.state_id = params.state_id.id;
        if (params.city_id) params.city_id = params.city_id.id;
        if (params.gender) params.gender = params.gender.id;

        return axios.put(`/api/user`, params, headers);
    }
}



// WEBPACK FOOTER //
// ./resources/site/js/providers/api/user-service.js